import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { DeleteLabourForecastMutation } from '@/gql/graphql';

const DELETE_LABOUR_FORECAST_MUTATION = graphql(`
  mutation DeleteLabourForecast($id: ID!) {
    deleteLabourForecast(id: $id)
  }
`);

const useDeleteLabourForecast = (
  projectId: string,
  options?: UseMutationOptions<DeleteLabourForecastMutation, unknown, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      return gqlClient.request(DELETE_LABOUR_FORECAST_MUTATION, { id });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.labourForecasts(projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.profitBreakdown(projectId),
      });
    },
    ...options,
  });
};

export default useDeleteLabourForecast;
